import React from 'react'

import {Box} from '@vio/atlas/helpers/Box'
import {SkeletonLoader} from '@vio/atlas/SkeletonLoader'

export const PrimaryRoomOfferLoading = () => (
  <Box display="flex" flexDirection="column" gap="s600">
    <div>
      <SkeletonLoader width={139} />
      <SkeletonLoader width={90} />
    </div>
    <div>
      <SkeletonLoader width={56} align="right" />
      <SkeletonLoader width={86} align="right" />
    </div>
  </Box>
)
